// FILECONTENT_START src/common/components/DataGrid/row-buttons/ActionButtonEdit.tsx
import EditIcon from "@mui/icons-material/Edit";
import I18n from "i18n-js";
import { Link } from "react-router-dom";
import { DataGridActionButtonProps } from "../DataGrid";
import { GridActionsCellItem } from "../grid-imports";

export default function ActionButtonEdit({
  to,
  onClick,
  disabled,
}: DataGridActionButtonProps) {
  if (to) {
    return (
      <GridActionsCellItem
        icon={<EditIcon />}
        label={I18n.t("App.edit")}
        title={I18n.t("App.edit")}
        //@ts-ignore
        to={to}
        component={Link}
        disabled={disabled}
        //color="inherit"
      />
    );
  }
  return (
    <GridActionsCellItem
      icon={<EditIcon />}
      label={I18n.t("App.edit")}
      title={I18n.t("App.edit")}
      onClick={onClick ? () => onClick() : undefined}
      disabled={disabled}
      //color="inherit"
    />
  );
}

// FILECONTENT_END src/common/components/DataGrid/row-buttons/ActionButtonEdit.tsx